import React from 'react'

export default function Loader() {
  return (
    <div className='d-flex flex-column justify-content-center align-items-center w-100 h-full'>
        <div class="lds-ripple"><div></div><div></div></div>
        <span className='mt-4 text-primary'>لطفا صبر کنید...</span>
    </div>
  )
}
